import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CopyCard from './CopyCard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { downloadPropertyPDF } from '../utils/pdfGenerator';
import { downloadInstagramPost } from '../utils/imageGenerator';
import ReelModal from './ReelModal';

const ResultsView = ({ results, formData, onReset }) => {
  const [isReelOpen, setIsReelOpen] = useState(false);
  
  // Estados de carga para retroalimentación visual
  const [isDownloadingImage, setIsDownloadingImage] = useState(false);
  const [isDownloadingPDF, setIsDownloadingPDF] = useState(false);

  const handleDownloadPDF = async () => {
    setIsDownloadingPDF(true);
    try {
      await downloadPropertyPDF(formData, results?.description || '');
    } catch (error) {
      console.error("Error PDF:", error);
      alert("Hubo un error al generar el PDF. " + error.message);
    } finally {
      setIsDownloadingPDF(false);
    }
  };

  const handleDownloadImage = async () => {
    setIsDownloadingImage(true);
    try {
      await downloadInstagramPost(formData);
    } catch (error) {
      console.error("Error Imagen:", error);
      alert("Hubo un error al generar la imagen. " + error.message);
    } finally {
      setIsDownloadingImage(false);
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="space-y-6"
    >
      {/* Botón para volver al listado */}
      <div className="flex justify-start">
        <button 
          onClick={onReset}
          className="group flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:text-emerald-900 transition-colors bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-200 hover:bg-emerald-50 hover:border-emerald-200"
        >
          <SafeIcon icon={FiIcons.FiArrowLeft} className="transition-transform group-hover:-translate-x-1" />
          Volver al Panel Administrativo
        </button>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-emerald-50 p-6 rounded-xl border border-emerald-100 relative overflow-hidden">
        <div className="flex-grow z-10">
          <h2 className="text-xl font-bold text-emerald-900 flex items-center gap-2">
            <SafeIcon icon={FiIcons.FiCheckCircle} className="text-emerald-500" />
            Kit de Venta de Propiedad
          </h2>
          <p className="text-emerald-700 text-sm mt-1">
            Reutiliza los recursos generados para tus campañas de marketing.
          </p>
        </div>
        
        <div className="flex flex-wrap gap-3 w-full md:w-auto z-10">
          <button 
            onClick={() => setIsReelOpen(true)}
            className="flex-grow md:flex-grow-0 px-5 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-all text-sm font-bold flex items-center justify-center gap-2 shadow-sm"
          >
            <SafeIcon icon={FiIcons.FiPlayCircle} />
            Generar Reel
          </button>

          <button 
            onClick={handleDownloadImage}
            disabled={isDownloadingImage}
            className={`flex-grow md:flex-grow-0 px-5 py-2.5 rounded-lg transition-all text-sm font-semibold flex items-center justify-center gap-2 shadow-sm ${isDownloadingImage ? 'bg-emerald-400 cursor-wait text-white' : 'bg-emerald-600 hover:bg-emerald-700 text-white active:scale-95'}`}
          >
            {isDownloadingImage ? <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" /> : <SafeIcon icon={FiIcons.FiDownload} />}
            {isDownloadingImage ? 'Generando...' : 'Imagen'}
          </button>

          <button 
            onClick={handleDownloadPDF}
            disabled={isDownloadingPDF}
            className={`flex-grow md:flex-grow-0 px-5 py-2.5 rounded-lg transition-all text-sm font-semibold flex items-center justify-center gap-2 shadow-sm ${isDownloadingPDF ? 'bg-emerald-600 cursor-wait text-white' : 'bg-emerald-800 hover:bg-emerald-900 text-white active:scale-95'}`}
          >
            {isDownloadingPDF ? <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" /> : <SafeIcon icon={FiIcons.FiFileText} />}
            {isDownloadingPDF ? 'Generando...' : 'PDF'}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CopyCard 
          title="Descripción Profesional" 
          content={results.description} 
          icon={FiIcons.FiGlobe} 
        />
        <CopyCard 
          title="Copy para Redes Sociales" 
          content={results.instagram} 
          icon={FiIcons.FiInstagram} 
        />
      </div>

      <ReelModal 
        isOpen={isReelOpen} 
        onClose={() => setIsReelOpen(false)} 
        formData={formData} 
      />
    </motion.div>
  );
};

export default ResultsView;